<template>
  <div class="app-container">
    <list ref="list" @deleted="reload" >
    
        <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="100">
                <template slot-scope="{row}">
                    <el-button v-if="$permission.canRead()"   type="text" @click="edit(row)">查看</el-button>
                </template>
            </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" ></edit-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/business/stock/workorderunbinding/list'
import editDialog from '@/components/business/stock/workorderunbinding/editDialog'


export default {  
  name: 'workorderunbinding',
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  data(){
    return {
      api: require("@/api/production/unBindMaterial").default,
    }
  },
  methods: {
    edit(row){
      this.$refs.editDialog.open().then(that => {
        that.setData(row)
      })
    }
  }
  
};
</script>